import {
  Action,
  AnyAction,
  applyMiddleware,
  combineReducers,
  compose,
  createStore,
  Store,
} from 'redux';
import thunk from 'redux-thunk';
import {
  immutableBoolReducer,
  immutableStringReducer,
} from '../../shared/reducers/immutable-reducers';

// @ts-expect-error
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export function configureStore<State = $TSFixMe, A extends Action = AnyAction>(
  reducers: $TSFixMe,
  initialState: $TSFixMe = {},
  middleware: $TSFixMe[] = [],
  userIdentifier = 'unknown'
): Store<State, A> {
  if (initialState instanceof Function) {
    initialState = initialState();
  }

  return createStore(
    combineReducers({
      ...reducers,
      userIdentifier: immutableStringReducer,
      authenticated: immutableBoolReducer,
      onboarding: immutableBoolReducer,
    }),
    {
      authenticated: true,
      onboarding: false,
      userIdentifier,
      ...initialState,
    },
    composeEnhancers(applyMiddleware(thunk, ...middleware))
  );
}
